<article class="agu-card" [class.agu-card--recommended]="Recommended" [class.agu-card--pinned]="Pinned" [class.agu-card--closed]="Closed" [class.agu-card--tappable]="Tappable" (click)="OnRowClick($event)">
    <div class="agu-card__chips">
        @if (Recommended) {
            <!-- On a phone this pill is a 24px icon dot, so it carries its own name (P/Member_Hub.html:681-688, 983-984). -->
            <span class="agu-card__chip agu-card__chip--rec" role="img" aria-label="Recommended for you" title="Recommended for you">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4z" /></svg>
                Recommended
            </span>
        }
        @if (Pinned && ShowPinnedChip) {
            <span class="agu-card__chip agu-card__chip--pinned"><i class="fa-solid fa-thumbtack" aria-hidden="true"></i> Pinned</span>
        }
        <ng-content select="[chips]" />
        @if (IsNew) {
            <span class="agu-card__chip agu-card__chip--new" role="img" aria-label="New" title="New">New</span>
        }
    </div>
    <button
        type="button"
        class="agu-card__save agu-hit-24"
        (click)="SaveToggled.emit(!Saved)"
        [attr.aria-pressed]="Saved"
        [attr.aria-label]="SaveAriaLabel"
    >
        <agu-icon Name="saved" [Size]="17" />
    </button>
    <ng-content select="[title]" />
    <ng-content select="[sub]" />
    <ng-content select="[facts]" />
    <ng-content select="[why]" />
    <!-- One bottom-pinned block (CSV 2026-10-24, People Finder row 1): CTAs, Pin and Not for me sit at the same y in every card of a row. -->
    <div class="agu-card__bottom">
        <div class="agu-card__ctas"><ng-content select="[ctas]" /></div>
        <footer class="agu-card__foot">
            @if (ShowPin) {
                <button type="button" class="agu-card__quiet" (click)="PinToggled.emit(!Pinned)" [attr.aria-pressed]="Pinned" [attr.title]="Pinned ? 'Pinned' : 'Pin'">
                    <i class="fa-solid fa-thumbtack" aria-hidden="true"></i> {{ Pinned ? 'Pinned' : 'Pin' }}
                </button>
            }
            @if (ShowDismiss) {
                <button type="button" class="agu-card__quiet agu-card__quiet--right" (click)="Dismissed.emit()" title="Not for me"><span aria-hidden="true">✕</span> Not for me</button>
            }
            <ng-content select="[footer]" />
        </footer>
    </div>
</article>
